import { render } from "./MessageSendDrawer.vue?vue&type=template&id=7cd70bd2&scoped=true"
import script from "./MessageSendDrawer.vue?vue&type=script&lang=js"
export * from "./MessageSendDrawer.vue?vue&type=script&lang=js"

import "./MessageSendDrawer.vue?vue&type=style&index=0&id=7cd70bd2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cd70bd2"]])

export default __exports__